import { useNavigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';
import { getAds } from '../services/adApi';
import AdBanner from '../components/AdBanner';
import TopRatedDoctors from '../components/TopRatedDoctors';
import { Icon, IconBox, PageHero } from '../components/ui';


const ModeBanner = ({ title, subtitle, cta, onClick, bg, illustration, icon }) => (
  <button
    type="button"
    onClick={onClick}
    className="ds-service"
    style={{ textAlign: 'left', cursor: 'pointer', padding: 0, flexDirection: 'row', minHeight: 196, fontFamily: 'inherit' }}
  >
    <div style={{ flex: 1, minWidth: 0, padding: 'clamp(18px,3vw,24px)', display: 'flex', flexDirection: 'column', gap: 8 }}>
      <IconBox tone="indigo"><Icon name={icon} size={19} /></IconBox>
      <div className="t-meta" style={{ marginTop: 4 }}>Make an appointment for</div>
      <h2 className="ds-service-title" style={{ fontSize: 17 }}>{title}</h2>
      <p className="ds-service-desc">{subtitle}</p>
      <span className="ds-btn ds-btn--sm" style={{ alignSelf: 'flex-start', marginTop: 6, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {cta} <Icon name="arrowRight" size={14} />
      </span>
    </div>
    <div
      aria-hidden
      className="mode-banner-illustration ds-service-media"
      style={{ '--svc-bg': bg, margin: 8, height: 'auto', fontSize: 56 }}
    >
      <span className="ds-service-emoji">{illustration}</span>
    </div>
  </button>
);
const OnlineConsultation = () => {
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const { isAuthenticated } = useAuth();
  const [ads, setAds] = useState([]);
  const [adsLoading, setAdsLoading] = useState(true);

  useEffect(() => {
    if (!tenant?.id) return;
    setAdsLoading(true);
    getAds(tenant.id, 'CONSULTATION_PAGE')
      .then(setAds)
      .finally(() => setAdsLoading(false));
  }, [tenant?.id]);

  const handleOfflineClick = () => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: '/services/hospitals' } });
    } else {
      navigate('/services/hospitals');
    }
  };

  if (!tenant) {
    return (
      <div className="page">
        <main className="page-main">
          <div className="breadcrumb">
            <button className="t-link" onClick={() => navigate('/')}>Home</button>
            <span>›</span>
            <span className="bc-current">Doctors</span>
          </div>
          <PageHero
            title="Consult a Doctor"
            icon={<Icon name="stethoscope" size={30} style={{ color: 'var(--ds-primary)' }} />}
            subtitle="Select a tenant from the top bar to see available doctors."
            art="doctor"
          />
        </main>
      </div>
    );
  }

  return (
    <div className="page">
      <main className="page-main">
        <div className="breadcrumb">
          <button className="t-link" onClick={() => navigate('/')}>Home</button>
          <span>›</span>
          <span className="bc-current">Doctors</span>
        </div>

        <PageHero
          title="Consult a Doctor"
          icon={<Icon name="stethoscope" size={30} style={{ color: 'var(--ds-primary)' }} />}
          subtitle="Speak to a certified doctor online or visit one near you."
          art="doctor"
        />

        {/* ── Ad / Campaign Banners ── */}
        <div className="fade-up">
          <AdBanner ads={ads} loading={adsLoading} label="Featured Campaigns" />
        </div>

        <div
          className="fade-up-1"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 'var(--ds-gap)',
            marginBottom: 'var(--ds-section)',
          }}
        >
          <ModeBanner
            title="Online Consultation"
            subtitle="Connect with doctors via video or chat — from the comfort of home."
            cta="Book Appointment"
            onClick={() => navigate('/services/book-appointment?mode=online&secondOpinion=false')}
            icon="video"
            bg="#dff7fb"
            illustration="📱"
          />
          <ModeBanner
            title="Second Opinion"
            subtitle="Already have a diagnosis? Upload your reports and a specialist will review them."
            cta="Request Second Opinion"
            onClick={() => navigate('/services/book-appointment?mode=online&secondOpinion=true')}
            icon="shield"
            bg="#f1eaff"
            illustration="🔍"
          />
          <ModeBanner
            title="Offline Consultation"
            subtitle="Find hospitals and clinics near you for in-person visits and appointments."
            cta="Find nearby hospitals"
            onClick={handleOfflineClick}
            icon="hospital"
            bg="#e6e9ff"
            illustration="🏥"
          />
        </div>

        {/* ── Top Rated Doctors ── */}
        <div className="fade-up-2">
          <TopRatedDoctors limit={3} />
        </div>

      </main>
    </div>
  );
};

export default OnlineConsultation;